import React from 'react'

export default function TabsPane ({fn}) {
    return (
       <div className="tabsPane">
            {fn && fn.fn && fn.fn()}
        </div>
    )
}